function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4605.27,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M63630 17652l-21371 0c-4292,0 -7771,3480 -7771,7771l0 9714m17485 -5827l11658 -11656 -11658 -11656m3885 34968l0 19427c0,2147 -1739,3886 -3885,3886l-34969 0c-2145,0 -3886,-1739 -3886,-3886l0 -31084c0,-2145 1740,-3886 3886,-3886l5828 0"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 76750 76750",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/get-link.7590ae5c.svg";
export { SvgComponent as ReactComponent };